import { Input } from "@public/ui-toolkit";
import { Col, Empty, Menu, Row, Dropdown, Spin, Layout, Popconfirm, Badge } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react";
import SelectDropDown from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { createAllocatorNetworks, deleteAllocatorNetwork, getAllocatorNetworks, getAllocatorNetworkStats, getAllocatorUsers, getInvestorTypes, updateAllocatorNetworks } from "./actions";
import { getNumberWithUnit } from "@hedgefund/shared";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router";
import { debounce } from "lodash";
import { createRoom } from "../FundDetail/actions";


const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "180px",
    minHeight: "50px",
    padding: 4,
  }),
};

const networkType = [
  {
    name: "All Allocators",
    id: 0,
    badge: null
  },
  {
    name: "My Allocators",
    id: 1,
    badge: "myConnection"

  },
  {
    name: "Allocator Requests",
    id: 3,
    badge: "request"

  },
  {
    name: "Sent Requests",
    id: 2,
    badge: "requestSent"

  },
  {
    name: "Blocked Allocators",
    id: 4,
    badge: "blocked"

  }
]
const networkStatus = [
  {
    name: "Pending",
    id: 0
  },
  {
    name: "Accepted",
    id: 1
  },
  {
    name: "Rejected",
    id: 2
  },
  {
    name: "Blocked",
    id: 3
  }
]
const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const { Sider } = Layout;
const AllocatorNetworks = () => {

  const [searchResult, setSearchResult] = useState("");
  const [investorTypeId, setInvestorTypeId] = useState({});
  const [tenantId, setTenantId] = useState(null);
  const [tabType, setTabType] = useState(0);
  const [chatLoading, setChatLoading] = useState(false);


  var history = useHistory();
  const AllocatorNetworkState = useSelector((state) => state.allocatorNetwork)
  const { allocatorNetworks, userLoading, anLoading, allocatorUsers, currentPage, perPage, totalPages, networkStats, investorTypes } = AllocatorNetworkState;
  const items = [
    {
      key: 0,
      label: "Allocator Chat",
    },
    ...allocatorUsers?.map((data, index) => {
      return ({
        key: data.id,
        label: data?.fullName,
      })
    })
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    const user = jwt_decode(localStorage.getItem("token") ? localStorage.getItem("token") : sessionStorage.getItem("token"));
    setTenantId(user?.["http://www.aspnetboilerplate.com/identity/claims/tenantId"]);

    AllocatorNetworkList(1);

    dispatch(getAllocatorNetworkStats());

    dispatch(getInvestorTypes());

  }, [dispatch])



  const AllocatorNetworkList = (page = currentPage + 1, type, investorId = null, value = null) => {
    dispatch(getAllocatorNetworks({
      keyword: value,
      type: type,
      investorTypeId: investorId?.value,
      page: page,
      perPage: perPage,
      sortBy: 1,
      sortByColumn: "CreationTime"
    }));
  }
  const handleSearch = debounce((text) => {
    setSearchResult(text);
    AllocatorNetworkList(1, tabType, investorTypeId, text);
  }, 1500);
  const investorTypeList = [
    {
      name: "All",
      id: null,
    },
    ...investorTypes,
  ];

  const createNetwork = (status, receiverId) => {
    const Obj = {
      status: status,
      receiverId: receiverId
    }
    dispatch(createAllocatorNetworks(Obj));
  }
  const updateNetwork = (status, receiverId, id) => {
    const Obj = {
      id: id,
      status: status,
      receiverId: receiverId
    }
    dispatch(updateAllocatorNetworks(Obj))
  }

  const allocatorProfile = (id) => {
    history.push(`/allocator/${id}`)
  }
  const deleteNetwork = (id) => {
    dispatch(deleteAllocatorNetwork(id));
  }

  const onClickTab = (key) => {
    setTabType(key);
    AllocatorNetworkList(1, key);
  }

  function handleScroll() {
    var reachedBottom1 = window.scrollY + window.innerHeight > document.documentElement.scrollHeight * 0.9;
    if (!anLoading && totalPages > currentPage && reachedBottom1) {
      AllocatorNetworkList();
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [anLoading]);

  const joinChatRoom = (body) => {
    setChatLoading(true);
    dispatch(
      createRoom(body, (roomId) => {
        setChatLoading(false);
        history.push(`/chat?identifier=${roomId}&type=0`);
      })
    );
  }

  const onContactClick = ({ key }) => {
    const body = {
      tenantId,
      type: key === "0" ? RoomType[1].id : RoomType[0].id,
      ...(key !== "0" && { userId: key }),
    };
    joinChatRoom(body);
  }
  return (

    (chatLoading === true) ?
      (<main className="main-doc">
        <div className="main-inner">
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Spin />
            </Col>
          </Row>
        </div>
      </main>)
      :
      (<main className="main-doc">
        <div className="main-inner">
          <div className="col-lg-12 p-2 mt-4 ml-4 mr-4">
            <Row>
              <Col span={6}>
                <Sider
                  width={400}
                  style={{
                    position: 'fixed',
                    height: "720px",
                    backgroundColor: "#fff",
                    border: "1px solid gray"
                  }}
                >
                  <Col span={24}>
                    <div className="mt-3" >
                      <h4 style={{ textAlign: "center", color: "#000" }}>Manage My Networks</h4>
                      <hr />
                    </div>
                    <div className="mt-4" style={{ textAlign: "center" }}>
                      <Menu
                        style={{
                          backgroundColor: "#B039CC !important"
                        }}
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                      >
                        {
                          networkType.map(
                            (obj) => {
                              return (
                                <Menu.Item key={obj.id + 1} onClick={(e) => onClickTab(obj.id)} >
                                  <span>{obj.name} </span>

                                  {obj.badge && (<Badge count={networkStats[obj.badge] ? networkStats[obj.badge] : 0} showZero color='#29b6f6' />)}

                                </Menu.Item>)
                            })}
                      </Menu>
                    </div>
                  </Col>
                </Sider>
              </Col>
              <Col span={17} className="p-3 bg-white" style={{ border: "1px solid gray", borderRadius: "1%" }} >
                <div className="mt-3">
                  <h6 className="ml-3 p-1s">{networkType[tabType].name}</h6>
                  <Row>
                    <Col span={19} className=" ml-4 ">
                      <Input
                        placeholder="Search"
                        label="Search"
                        type="text"
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                      />
                    </Col>
                    <Col span={4} className="ml-2">
                      <SelectDropDown
                        styles={customStyles}
                        onChange={(e) => {
                          setInvestorTypeId(e)
                          AllocatorNetworkList(null, tabType, e, searchResult);
                        }}
                        defaultValue={investorTypeId.value > 0 ? investorTypeId : { value: "InvestorType", label: "InvestorType" }}
                        options={investorTypeList.map((item) => { return ({ value: item.id, label: item?.name }) })}
                      />
                    </Col>
                  </Row>
                  <p className="ml-4" style={{ color: "gray" }}>Showing Results For Allocator</p>
                </div>

                <Row className="ml-4" >
                  {allocatorNetworks?.length > 0 ? (
                    allocatorNetworks?.map((item) => {
                      return (
                        <Col span={5} className="ml-4 mb-3">
                          <div className="hf-card2" >
                            <div
                              onClick={() => allocatorProfile(item.id)}
                              className="hf-card2-banner search-fund-card "
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                style={{ width: "100%", height: "150px" }}
                                src={item.logo ? item.logo : "/assets/images/bg1.png"}
                                className="company-banner-img "
                                alt="..."
                              />
                              {/* <div style={{ objectFit: "cover" }}>
                                <img className="user-Fund-Card" src={item.logo ? item.logo : "/assets/images/bg1.png"} alt="Profile Image" />
                              </div> */}
                            </div>
                            <div className="hf-card-body p-3" style={{ textAlign: "center" }}>
                              <ul className="extra-info mt-2">
                                <li className="mb-2" style={{ height: "35px" }}>

                                  <span className="text-dark" style={{ fontSize: "14px", fontWeight: "600", cursor: "pointer" }}>
                                    {item?.name}
                                  </span>
                                </li>
                                <li className="mb-3" style={{ height: "35px" }}>
                                  <i className="fa fa-map-marker mr-1"></i>
                                  <span className="text-blue">
                                    {item?.address ? item?.address?.substring(0, 60) + " ...." : "N/A"}
                                  </span>
                                </li>
                                <li className="mb-3">
                                  <span class="badge badge-info p-1 mr-2 ">AUM: {item?.aum ? getNumberWithUnit(item?.aum) : "N/A"} </span>
                                  <span class="badge badge-secondary p-1 ">Phone :  {item?.phoneNumber ? item?.phoneNumber : "N/A"}</span>
                                </li>
                              </ul>
                            </div>
                            <div className="hf-card-footer">
                              <div className="row" style={{ height: '50px' }}>
                                {(() => {
                                  if (networkStatus[0].id === item.recieverNetwork?.status) {
                                    return (
                                      <Row>
                                        <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <Popconfirm
                                            title={item.name}
                                            description="Are you sure to cancel it?"
                                            onConfirm={() => deleteNetwork(item?.recieverNetwork?.id)}
                                          >
                                            <button className="border-0 bg-transparent p-0 btn-fund-card" >
                                              <i className="fa fa-plus mr-1" style={{ color: "white" }} ></i>
                                              Pending
                                            </button>
                                          </Popconfirm>
                                        </Col>
                                      </Row>
                                    )
                                  } else if (networkStatus[0].id === item.senderNetwork?.status) {
                                    return (
                                      <Row>
                                        <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <button
                                            className="border-0  p-0 btn-fund-card" onClick={() => updateNetwork(networkStatus[1].id, item.senderNetwork.senderId, item?.senderNetwork?.id)}
                                          >
                                            <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                            Accept
                                          </button>
                                        </Col>
                                        <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <button className="border-0  p-0 btn-fund-card" onClick={() => deleteNetwork(item?.senderNetwork?.id)}
                                          >
                                            <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                            Reject
                                          </button>
                                        </Col>
                                      </Row>
                                    )
                                  } else if (networkStatus[1].id === item.recieverNetwork?.status || networkStatus[1].id === item.senderNetwork?.status) {
                                    return (
                                      <Row>
                                        <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <Popconfirm
                                            // title={item.name}
                                            title={<div><p>{`Are you sure you want to remove`}</p><p>{`${item.name} as a connection?`}</p></div>}
                                            onConfirm={() => deleteNetwork(item?.recieverNetwork !== null ? item?.recieverNetwork?.id : item?.senderNetwork?.id)}
                                            okText={"Remove Connection"}
                                          >
                                            <button className="border-0 bg-transparen        t p-0 btn-fund-card">
                                              <i className={"fa fa-plus-square mr-1"} style={{ color: "white" }}></i>
                                              Connected
                                            </button>
                                          </Popconfirm>
                                        </Col>
                                        <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <Dropdown
                                            menu={{ items, onClick: onContactClick }}
                                            onOpenChange={() => {
                                              setTenantId(item?.id);
                                              dispatch(getAllocatorUsers(item?.id));
                                            }}>
                                            <button className="border-0 bg-transparent p-0 btn-fund-card" onClick={(e) => e.preventDefault()}>
                                              {(userLoading && tenantId === item?.id) ?
                                                <Spin indicator={<LoadingOutlined style={{ fontSize: 18, color: "white" }} />} /> :
                                                <i className={"fa fa-plus-square mr-1"} style={{ color: "white" }}></i>
                                              }
                                              Message
                                            </button>
                                          </Dropdown>
                                        </Col>
                                      </Row>
                                    )
                                  } else if (item.recieverNetwork === null || item.senderNetwork?.status === null) {
                                    return (
                                      <Row>
                                        <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <button
                                            className="border-0  p-0 btn-fund-card" onClick={() => createNetwork(networkStatus[0].id, item.id)}
                                          >
                                            <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                            Connect
                                          </button>
                                        </Col>
                                      </Row>
                                    )
                                  } else if (networkStatus[3].id === item.senderNetwork?.status) {
                                    return (
                                      <Row>
                                        <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                          <button
                                            className="border-0 p-0 btn-fund-card"
                                            onClick={() => updateNetwork(networkStatus[1].id, item?.senderNetwork?.receiverId, item.id)}
                                          >
                                            <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                            Blocked
                                          </button>
                                        </Col>
                                      </Row>
                                    )
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        </Col>
                      )
                    })
                  ) : (
                    <Row style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                      <Col span={24} >
                        <Empty />
                      </Col>
                    </Row>
                  )}
                  {anLoading ? (
                    <Col span={24} style={{ textAlign: "center" }}>
                      <Spin />
                    </Col>
                  ) : ""}
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </main>)

  );
};

export default AllocatorNetworks;
